import { Fragment } from 'react'
import { Button, Select, Tooltip, useModal } from '@panwds/react-ui'
import { useCallback, useEffect, useState } from 'react'
import { amendSubscriptionClaim } from '../../../common/actions/GlobalActions'
import { APP_ID_SDWAN } from '../../../common/constants/GlobalConstants'
import { FF_MODIFY_SUBSCRIPTION } from '../../../common/utils/FeatureFlags'
import { getVarValue } from '../../../common/utils/Sparky'
import {
  ACTION_BUTTON,
  CLAIM, CLAIM_BUTTON,
  CLAIMS_SUBSCRIPTION, EVAL_TO_PROD_SUBSCRIPTION,
  MODIFY_SUBSCRIPTION,
  RECLAIMS_SUBSCRIPTION, TOOLTIP_CLAIM_BUTTON,
  UNCLAIM,
  UPDATE
} from '../constants/SubscriptionConstant'
import { DATA_TEST_CLAIM_LICENSE, DATA_TEST_UN_CLAIM_LICENSE } from '../constants/TestingDataIds'
import ClaimSubscriptionModal from '../modals/ClaimSubscriptionModal'
import ModifySubscriptionModal from '../modals/ModifySubscriptionModal'
import UnClaimSubscriptionModal from '../modals/UnClaimSubscriptionModal'
import './ButtonRenderer.scss'
import SDWANButtonRenderer from './SDWANButtonRenderer'

/*
 * Created By sswaminathan
 * Created on Mon Nov 22 2021
 * Created on ButtonRenderer.js
 * Copyright (c) 2021  ©Palo Alto Networks
 */


const ButtonRenderer = ({ content, row, value, handleSubmit, title, setUpdateLoading, ...rest }) => {
  const { setShowErrorMsg, setShowError } = rest
  const claimsModal = useModal(ClaimSubscriptionModal)
  const unClaimModal = useModal(UnClaimSubscriptionModal)
  const modifySubscriptionModal = useModal(ModifySubscriptionModal)
  const [items, setItems] = useState([])
  const [header, setHeader] = useState('')

  const updateHandler = useCallback(async () => {
    const { hash, pending_hash, claimed_by_tenant_name, support_account_id } = row.leafRows[0].original
    setUpdateLoading(true)
    const request = {
      hash: hash,
      pending_hash: pending_hash,
      tsg_name: claimed_by_tenant_name,
      support_account_id: support_account_id
    }
    const response = await amendSubscriptionClaim(row.leafRows[0].original.tsg_id, request)
    if (response.isSuccess) {
      setShowError(false)
      handleSubmit('Update Subscription Successfully', false)
    }
    else {
      setShowError(true)
      setShowErrorMsg('Error Updating The Subscription')
    }
    setUpdateLoading(false)
  }, [handleSubmit, row.leafRows, setShowError, setShowErrorMsg, setUpdateLoading])
  const getModal = useCallback((modalType) => {
    switch (modalType) {
      case UNCLAIM: {
        return { modal: unClaimModal, header: RECLAIMS_SUBSCRIPTION }
      }
      case MODIFY_SUBSCRIPTION: {
        return { modal: modifySubscriptionModal, header }
      }
      default: {
        return { modal: claimsModal, header: CLAIMS_SUBSCRIPTION }
      }
    }
  }, [claimsModal, header, modifySubscriptionModal, unClaimModal])

  useEffect(() => {
    setHeader(row.leafRows[0].original.isEval ? EVAL_TO_PROD_SUBSCRIPTION : MODIFY_SUBSCRIPTION)
    if (row.isGrouped && row.leafRows?.length > 0) {
      setItems((prev) => {
        const value = []
        if (row.leafRows[0].original.allocation_type === 'PENDING') {
          value.push({ value: UNCLAIM })
        }
        getVarValue(FF_MODIFY_SUBSCRIPTION, false) && value.push({ value: row.leafRows[0].original.isEval ? EVAL_TO_PROD_SUBSCRIPTION : MODIFY_SUBSCRIPTION })
        return value
      })
    }
  }, [row.isGrouped, row.leafRows])
  const handleOnchange = useCallback((value, rowInfo) => {
    const { header, modal } = getModal(value)
    modal.openModal({ title: header, row: rowInfo, handleSubmit: handleSubmit, ...rest })
  }, [getModal, handleSubmit, rest])
  return (
    row.leafRows.map((each, idx) => {
      if (!each.original.is_header) {
        return <Fragment key={idx} />
      }
      const action = each.original.actions
      return <Fragment key={idx}>
        {each.original.is_header &&
        <div className="tw-flex tw-flex-row tw-w-full tw-text-sm tw-h-full tw-justify-center">
          {action === CLAIM && each.original.image_name !== APP_ID_SDWAN &&
          <div className='tw-flex tw-flex-1 tw-justify-center'>
            <Tooltip label={each.original.block_claim ? each.original.block_claim : rest.userFlow.length ? TOOLTIP_CLAIM_BUTTON : CLAIM_BUTTON}>
              <Button appearance="primary" disabled={each.original.block_claim} size="md"
                data-testid={DATA_TEST_CLAIM_LICENSE}
                onClick={() => claimsModal.openModal({ title: title, row: each, handleSubmit: handleSubmit, ...rest })}>
                {action}
              </Button>
            </Tooltip>
          </div>}
          {action === CLAIM && each.original.image_name === APP_ID_SDWAN &&
          <SDWANButtonRenderer {...{ action, row: each, title, handleSubmit, rest, claimsModal }}/>
          }
          {action === UNCLAIM &&
          <div className='tw-flex tw-flex-1 tw-justify-center'>
            <Select
              addClassName='cmm-modal-select'
              button={
                <Button isMenu appearance="primary" data-testid={DATA_TEST_UN_CLAIM_LICENSE}>
                  {ACTION_BUTTON}
                </Button>
              }
              defaultPlacement='bottom-end'
              items={items}
              onChange={
                (value) => {
                  value?.selectedItem?.value === UNCLAIM ? handleOnchange(UNCLAIM, each) : handleOnchange(MODIFY_SUBSCRIPTION, each)
                }
              }
              selectedItem={[]}
            />
          </div>}
          {action === UPDATE &&
          <div className='tw-flex tw-flex-1 tw-justify-center'>
            <Button appearance="primary" disabled={each.original.block_claim} size="md"
              data-testid={DATA_TEST_CLAIM_LICENSE}
              onClick={updateHandler}>
              {action}
            </Button>
          </div>}
        </div>}
      </Fragment>

    })
  )
}

export default ButtonRenderer
